export default "__VITE_ASSET__DUiouQWN__"